import React from 'react';
import { Helmet } from 'react-helmet';

export default function(props) {
  const show = props.activeShow || props.show || {};
  const episode = props.activeEpisode || props.episode || {};
  let title = 'Clipps | Podcast Discovery';
  let description =
    'Clipps is a podcast streaming platform that helps you discover new shows around your interests. Sign up today and be the first to try @ClippsApp!';
  let canonicalUrl = 'https://www.clip.ps';
  let author = 'Clipps';
  let keywords =
    'Podcasting, Podcast Discovery, Podcasts, Podcast Shows, Podcast Search, Podcasters, Clipps, Caster, CasterCommunity';

  if (show && show.title) {
    title = `${show.title} | Clipps`;
    description = show.description;
    keywords = show.keywords || show.categories;
    author = show.author;
    canonicalUrl = `https://www.clip.ps/${show.id}`;
  }

  if (episode && episode.title) {
    title = `${show.title} by ${episode.title} | Clipps`;
    description = episode.summary || show.description;
    keywords = episode.keywords || show.keywords || show.categories;
    canonicalUrl = `https://www.clip.ps/e/${episode.id}`;
  }

  if (window && window.location.href.indexOf('/l/') > -1) {
    title = `CasterLink | ${show.title}`;
    canonicalUrl = `https://www.clip.ps/l/${show.id}`;
  } else if (window && window.location.href.indexOf('community') > -1) {
    title = `Caster Community | A Community for Podcasters`;
    description =
      "A community of podcasters - learning, growing, building. We're a community of podcasters with a shared goal to create fantastic audio content for our listeners.";
    canonicalUrl = `https://www.clip.ps/community`;
  } else if (window && window.location.href.indexOf('privacy') > -1) {
    title = 'Clipps | Privacy Policy';
    canonicalUrl = `https://www.clip.ps/privacy`;
  } else if (window && window.location.href.indexOf('terms') > -1) {
    title = 'Clipps | Terms of Use';
    canonicalUrl = `https://www.clip.ps/terms`;
  } else if (window && window.location.href.indexOf('submit') > -1) {
    title = 'Clipps | Submit Podcast Show';
    description = 'Submit your podcast RSS feed to be included in the Clipps discovery database';
    canonicalUrl = `https://www.clip.ps/submit`;
  } else if (window && window.location.href.indexOf('links') > -1) {
    title = 'CasterLink by Clipps';
    description =
      'CasterLink allows podcasters to build smart links for their shows. Sharing smart links routes your listeners to the right place, every time.';
    canonicalUrl = `https://www.clip.ps/links`;
  } else if (window && window.location.href.indexOf('tools/extract') > -1) {
    title = 'Clipps | Extract Podcast RSS Feed';
    description = 'Enter an iTunes URL or Podcast ID to extract RSS feed';
    canonicalUrl = `https://www.clip.ps/tools/extract`;
  } else if (window && window.location.href.indexOf('tools/topPodcasts') > -1) {
    title = 'Clipps | Top iTunes Podcasts';
    description = 'Select a genre to get the top podcast shows from iTunes';
    canonicalUrl = `https://www.clip.ps/tools/topPodcasts`;
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='title' property='title' content={title} />
        <meta name='title' property='og:title' content={title} />
        <meta name='twitter:title' content={title} />
        <meta name='description' property='description' content={description} />
        <meta name='description' property='og:description' content={description} />
        <meta name='twitter:description' content={description} />
        <meta name='keywords' content={keywords} />
        <link rel='canonical' href={canonicalUrl} />
        <meta name='author' content={author} />
        <meta property='og:site_name' content='Clipps | Podcast Discovery Service'/>
        <meta property='og:image' content='https://blog.clip.ps/wp-content/uploads/2019/06/clippsBanner.jpg'/>
        <meta property='og:image:secure_url' content='https://blog.clip.ps/wp-content/uploads/2019/06/clippsBanner.jpg'/>
        <meta name='twitter:image' content='https://blog.clip.ps/wp-content/uploads/2019/06/clippsBanner.jpg'/>
        <meta property='og:image:width' content='1835'/>
        <meta property='og:image:height' content='702'/>
        <link rel='apple-touch-icon' sizes='192x192' href='https://blog.clip.ps/wp-content/uploads/2019/06/clippsSocial-md.jpg'/>
        <link rel='apple-touch-icon' sizes='512x512' href='https://blog.clip.ps/wp-content/uploads/2019/06/clippsSocial.jpg'/>
      </Helmet>
    </>
  );
}
